/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LanguageEnum {
    DE = 'de',
    EN = 'en',
    IT = 'it',
    ES = 'es',
    FR = 'fr',
    RU = 'ru',
    UA = 'ua',
}
